 import { ICity } from "../../interfaces";

export const CityEmpty: ICity = { 
    id: "",
    name: "", 
    state: "",  
    _ts: 0 
 };